import axios from "axios";

// 1. Creamos la instancia de Axios
const apiClient = axios.create({
  // Tu URL base de la API, sácala de una variable de entorno si es posible
  baseURL: process.env.REACT_APP_BASE_URL,
});

// 2. Interceptor de Petición (Request Interceptor)
// Se ejecuta ANTES de que cada petición sea enviada.
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// --- INTERCEPTOR DE RESPUESTA CORREGIDO ---
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // La lógica de limpieza y redirección se mantiene igual
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("adsFilters");
      localStorage.removeItem("requestsFilters");
      localStorage.removeItem("departmentFilter");

      window.location.href = "/";

      // ¡EL CAMBIO CLAVE ESTÁ AQUÍ!
      // En lugar de rechazar la promesa, devolvemos una nueva promesa
      // que nunca se resuelve. Esto "traga" el error y evita que el
      // .catch() del componente se ejecute.
      return new Promise(() => {});
    }

    // Para cualquier otro error, SÍ lo propagamos para que el
    // componente pueda manejarlo.
    return Promise.reject(error);
  }
);

export default apiClient;
